import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

// Loaded at runtime from the intl-tel-input utilsScript - may never arrive
declare var intlTelInputUtils: any;

export function betterEmailValidator(): ValidatorFn {

	return (control: AbstractControl): { [key: string]: any } | null => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		const valid = emailRegex.test(control.value);
		return valid ? null : { invalidEmail: true };
	};
}

export function betterFullNameValidator(): ValidatorFn {

	// Regex buildup:
	// Allow unlimited spaces before
	// Require a word
	// Allow unlimited spaces after word
	// Require another word
	// Allow unlimited spaces after second word and allow more words

	return (control: AbstractControl): { [key: string]: any } | null => {
		const fullNameRegex = /^[ ]*[\S]+[ ]+[\S]+[ \S]*/;
		const valid = fullNameRegex.test(control.value);
		return valid ? null : { invalidName: true };
	};
}

export function betterPhoneNumberValidator(getIntlInstance: () => any, validatorState: { isValidating: boolean }): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {

		const intlInstance = getIntlInstance();

		// Library couldn't load correctly. Don't give an error
		if (!intlInstance || typeof intlInstance.isValidNumber !== 'function') {
			console.error('intlInstance or isValidNumber method not available');
			return null;
		}

		// DEV-7562: without the utilsScript, isValidNumber() returns null for every number,
		// which would read as invalid and leave the visitor unable to submit. That is the
		// same "library couldn't load" case as above - don't give an error.
		if (typeof intlTelInputUtils === 'undefined') {
			return null;
		}

		if( ! control.value ) {
			console.warn( 'No value to validate' );
			return { invalidPhoneNumber: true };
		}

		// Guard flag prevents the countrychange event (fired by setNumber) from
		// triggering updateValueAndValidity, which would cause an infinite loop
		validatorState.isValidating = true;
		intlInstance.setNumber( control.value );
		validatorState.isValidating = false;

		// Use the intlTelInput instance to check if the number is valid
		const isValid = intlInstance.isValidNumber();

		// Never log the number itself: console output becomes a Bugsnag breadcrumb (DEV-7565)
		console.info( 'Is valid: ', isValid );

		if( ! isValid ) {

			const error = intlInstance.getValidationError();

			// Map error codes to user-friendly messages
			const errorMessages: { [key: number]: string } = {
				0: "The phone number is possible but may not be valid.",
				1: "Invalid country code. Please check the number and try again.",
				2: "The phone number is too short for the selected country.",
				3: "The phone number is too long for the selected country.",
				4: "The input provided is not a valid phone number.",
			};

			// Get the error message or a default message
			const errorMessage = errorMessages[error] || "An unknown error occurred.";

			console.warn( errorMessage );
		}

		// Return null if valid, or an error object if invalid
		return isValid ? null : { invalidPhoneNumber: true };
	};
}

export function atLeastOneMoverSelected(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const formGroup = control as any;
		const moversArray = formGroup.get('movers');
		if (!moversArray) return null;
		
		const selected = moversArray.controls.some((control: any) => control.get('checkbox')?.value);
		console.log('Selected:', selected);
		return selected ? null : { noMoverSelected: true };
	};
} 